import { useDispatch, useSelector } from 'react-redux'

import {
  clearFreePremiumMeals,
  freePremiumMealsAdd,
  freePremiumMealsRemove
} from 'src/redux-api-bridge/menu/actions'
import {
  addedAllFreePremiumMeals,
  getAvailableFreePremiumMeals,
  getFreePremiumMealsAvailableQuantity,
  getIsActiveFreePremiumMeals
} from 'src/redux-api-bridge/menu/selectors'
import { isActiveOrderConfirmed } from 'src/redux-api-bridge/order/selectors'
import {
  trackFreePremiumMealAdded,
  trackFreePremiumMealRemoved
} from 'src/utils/tracking'

export const useFreePremiumMeals = () => {
  const dispatch = useDispatch()

  const isEditingOrder = useSelector(isActiveOrderConfirmed)
  const isFreePremiumMealsActive = useSelector(getIsActiveFreePremiumMeals)
  const freePremiumMealsQty = useSelector(getFreePremiumMealsAvailableQuantity)
  const meals = useSelector(getAvailableFreePremiumMeals)
  const allFreePremiumMealsAdded = useSelector(addedAllFreePremiumMeals)

  const addFreePremiumMeal = meal => {
    if (allFreePremiumMealsAdded) return
    trackFreePremiumMealAdded(meal)
    dispatch(freePremiumMealsAdd({ meal }))
  }

  const removeFreePremiumMeal = meal => {
    trackFreePremiumMealRemoved(meal)
    dispatch(freePremiumMealsRemove({ meal }))
  }

  const clearAllFreePremiumMeals = () => dispatch(clearFreePremiumMeals())

  const showFreePremiumMealsBanner = !isEditingOrder && isFreePremiumMealsActive
  const showFreePremiumMealsModal = !isEditingOrder && isFreePremiumMealsActive

  return {
    addFreePremiumMeal,
    removeFreePremiumMeal,
    clearAllFreePremiumMeals,
    showFreePremiumMealsBanner,
    allFreePremiumMealsAdded,
    meals,
    freePremiumMealsQty,
    isFreePremiumMealsActive,
    showFreePremiumMealsModal
  }
}
